import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

const HeroDescription = () => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const description =
    labels.menuPages?.howItWorks?.hero?.description ||
    "Upptäck den revolutionerande vägen att köpa och sälja bilar. Från digital värdering till säker leverans - vi guidar dig genom hela processen.";

  return (
    <p className="text-lg sm:text-xl md:text-xl lg:text-2xl mb-6 md:mb-8 text-gray-300 max-w-3xl mx-auto lg:mx-0 leading-relaxed px-2 lg:px-0">
      {description}
    </p>
  );
};

export default HeroDescription;
